import { HourRangeOption, VisitTimeSlot } from '@/types/visit'

/** Format date to YYYY-MM-DD format for browser compatibility */
export const formatDate = (year: number, month: number, day: number): string => {
  const parsedMonth = month >= 10 ? month : `0${month}`
  const parsedDay = day >= 10 ? day : `0${day}`
  return `${year}-${parsedMonth}-${parsedDay}`
}

/** Encodes the information about the time range of a booked visit in a format accepted by the backend */
export const encodeVisitHours = (date: Date, hour: HourRangeOption) => {
  const month = date.getMonth() + 1 // getMonth is zero-based 🥲
  const day = date.getDate()
  const year = date.getFullYear()

  const [startHour, endHour] = hour.split('-')

  const end = new Date(formatDate(year, month, day))
  const start = new Date(formatDate(year, month, day))

  end.setHours(parseInt(endHour))
  start.setHours(parseInt(startHour))

  return {
    end,
    start,
  }
}

export const formatTwoDigitMinutes = (date: Date) => (date.getMinutes() < 10 ? '0' : '') + date.getMinutes()

export const decodeVisitHours = (visitDate: VisitTimeSlot) => {
  return {
    endHour: `${visitDate.end.getHours()}:${formatTwoDigitMinutes(visitDate.end)}`,
    startHour: `${visitDate.start.getHours()}:${formatTwoDigitMinutes(visitDate.start)}`,
  }
}
